import TextField from 'emerald-ui/lib/TextField';
import Button from 'emerald-ui/lib/Button';
import populateDocs from './utils/populateDocs';
import { useForm, Controller } from 'react-hook-form';

export default {
  ...populateDocs([{ component: TextField, componentName: 'TextField' }], 'TextField'),
  description: 'A styled input field.',
  codeSamples: [
    {
      title: 'Default',
      scope: { TextField },
      whiteBackground: true,
      code: `<TextField label="Label" />`,
    },
    {
      title: 'With react-hook-form',
      scope: { TextField, useForm, Controller, Button },
      whiteBackground: true,
      code: `// import { useForm, Controller } from 'react-hook-form';

function WithReactHookForm() {
  const { control, handleSubmit, errors } = useForm();

  const onSubmit = data => {
    console.log('Form data', data);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="firstName"
        control={control}
        defaultValue=""
        render={
          ({ onChange, value }) => (
            <TextField
              onChange={onChange}
              value={value}
              label="First name"
              errorMessage={errors.firstName && errors.firstName.message}
            />
          )
        }
        rules={{ required: 'This field is required' }}
      />
      <Controller
        name="lastName"
        control={control}
        defaultValue="Default last name"
        render={
          ({ onChange, value }) => (
            <TextField
              onChange={onChange}
              value={value}
              label="Last name"
            />
          )
        }
      />
      <Button type="submit" color="info" style={{ marginTop: '20px' }}>
        Submit form
      </Button>
    </form>
  )
}`,
    },
  ],
};
